import InnerComponent from '@Components/Purchase/OutgoingPayments/OutgoingPaymentsList';
import orgContainer from '@Components/AppContainer';

const OutgoingPaymentsList = () => ((orgContainer(InnerComponent)));
export default OutgoingPaymentsList;
